import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Stack,
} from '@chakra-ui/react';
import { FeaturesPresentationProps, FeatureItemProps } from '../types';
import FeatureCardPresentation from './FeatureCardPresentation';
import { SectionAnchor } from '../../../shared/components';

const FeaturesPresentation: React.FC<FeaturesPresentationProps> = ({
  id,
  heading,
  description,
  features
}) => {
  return (
    <>
      <SectionAnchor id={id} />
      <Box as="section" pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}>
      <Container maxW="container.xl">
        <Stack spacing={8} align="center" mb={16}>
          <Heading 
            as="h2" 
            size="xl"
            bgGradient="linear(to-r, brand.primary.dark, brand.primary.base)"
            bgClip="text"
            textAlign="center"
          >
            {heading}
          </Heading>
          <Text fontSize="lg" color="gray.600" maxW="800px" textAlign="center">
            {description}
          </Text>
        </Stack>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
          {features.map((feature: FeatureItemProps, index: number) => (
            <FeatureCardPresentation
              key={index}
              title={feature.title}
              text={feature.text}
              icon={feature.icon}
            />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
    </>
  );
};

export default FeaturesPresentation;